// import { Link as RouterLink } from 'react-router-dom';
// @mui
import {Stack, Typography } from '@mui/material';


// import { Alert, Tooltip, Stack, Typography, Link, Box } from '@mui/material';
// auth
// import { useAuthContext } from '../../auth/useAuthContext';
// routes
// import { PATH_AUTH } from '../../routes/paths';
// layouts
import { LoginText } from '../../components/logo';

import Image from '../../components/image';
import PRSLogo from '../../assets/logo.png';

import LoginLayout from '../../layouts/login';
//
import AuthLoginForm from './AuthLoginForm';

// import AuthWithSocial from './AuthWithSocial';

// ----------------------------------------------------------------------

export default function Login() {
  // const { method } = useAuthContext();

  return (
    <LoginLayout>
      <Stack spacing={2} sx={{ mb: 5, position: 'relative' }}>
        <Image
          disabledEffect
          visibleByDefault
          alt="auth"
          src={PRSLogo}
          sx={{
            width: { lg: 180, md: 150, sm: 130, xs: 120 },
            mb: { lg: 10, md: 8, sm: 5, xs: 4 },
            height: 'auto',
            alignSelf: 'center',
          }}
        />
        <Typography variant="h4">PRS Administration Portal Login</Typography>

        {/* <Stack direction="row" spacing={0.5}>
          <Typography variant="body2">New user?</Typography>

          <Link component={RouterLink} to={PATH_AUTH.register} variant="subtitle2">
            Create an account
          </Link>
        </Stack> */}

        {/* <Tooltip title={method} placement="left">
          <Box
            component="img"
            alt={method}
            src={`/assets/icons/auth/ic_${method}.png`}
            sx={{ width: 32, height: 32, position: 'absolute', right: 0 }}
          />
        </Tooltip> */}
      </Stack>

      {/* <Alert severity="info" sx={{ mb: 3 }}>
        Use email : <strong>demo@minimals.cc</strong> / password :<strong> demo1234</strong>
      </Alert> */}

      <AuthLoginForm />
      {/* <Typography sx={{ mt: 1 }}>
        Click here to <span style={{ fontWeight: 'bold' }}>Sign up</span>
      </Typography> */}
      {/* <AuthWithSocial /> */}
      <LoginText
        sx={{
          zIndex: 9,
          position: 'absolute',
          bottom: 0,
          color: '#22345B',
          mb: { xs: 1.5, md: 3 },
          mr: { xs: 2, md: 5 },
        }}
      />
    </LoginLayout>
  );
}
